import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../core/rootHooks';
import { AppDispatch, RootState } from '../../core/store';
import VesselDcf from './containers/VesselDcf';
import FleetDcf from './containers/FleetDcf';
import SummaryDcf from './containers/SummaryDcf';
import { getVesselDcfRequestAction, getSummaryDcfRequestAction } from './dcfSlice';
import { EOutputType } from '../../shared/sharedEnums';
import { selectSelectionData } from '../search/searchSelectors';
import { dcfVesselListSelector, selectDcfValueData } from './dcfSelectors';
import Logo from '../../shared/components/dashboard/Logo';
import DcfLogoSrc from '../../assets/images/logos/logo_dcf.svg';
import LoadingSpinner from '../../shared/components/loading-spinner/LoadingSpinner';
import Coverage from '../../shared/components/dashboard/Coverage';
import { selectIsMsi } from '../../user-management/appSelectors';

const Dcf: React.FC = () => {
	const { outputType } = useAppSelector(selectSelectionData);
	const dcfVesselList = useAppSelector(dcfVesselListSelector);
	const dcfValueData = useAppSelector(selectDcfValueData);

	const { vesselListDcf } = useAppSelector((state: RootState) => state.dcfSlice);
	const { summaryDcf } = useAppSelector((state: RootState) => state.dcfSlice);
	const isMsi = useAppSelector(selectIsMsi);

	const dispatch = useAppDispatch<AppDispatch>();

	useEffect(() => {
		if (dcfVesselList.length > 0) {
			const imoList = dcfVesselList.map((v) => v.imoNumber);

			if (outputType === EOutputType.Vessel || outputType === EOutputType.Fleet) {
				dispatch(getVesselDcfRequestAction(imoList));
			} else if (outputType === EOutputType.Summary) {
				dispatch(getSummaryDcfRequestAction(imoList));
			}
		}
	}, [dispatch, dcfVesselList, outputType]);

	return (
		<>
			<Logo src={DcfLogoSrc} />
			{vesselListDcf?.loading ? (
				<LoadingSpinner size="md" spinnerClassName="p-2" />
			) : outputType === EOutputType.Vessel ? (
				<VesselDcf vesselDcf={vesselListDcf?.dataList?.length === 1 ? vesselListDcf.dataList[0] : null} data={dcfVesselList[0]} />
			) : outputType === EOutputType.Fleet ? (
				<FleetDcf vesselListDcf={vesselListDcf} selectedVessels={dcfVesselList} />
			) : outputType === EOutputType.Summary ? (
				<SummaryDcf summaryDcf={summaryDcf} />
			) : null}
			{isMsi && (
				<Coverage
					vesselsCount={dcfValueData?.dcfValueData?.imoCount}
					calculatedVesselsCount={dcfValueData?.dcfValueData?.calculatedImoCount}
					coveragePercentage={dcfValueData?.dcfValueData?.coveragePercentage}
				/>
			)}
		</>
	);
};

export default Dcf;
